import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M13.5 6.5H2.5V12.5C2.5 13.0523 2.94771 13.5 3.5 13.5H12.5C13.0523 13.5 13.5 13.0523 13.5 12.5V6.5Z"
            fill="#F6F6F6"
            stroke="#979797"
            strokeLinecap="round"
        />
        <path
            d="M2.5 4.5V6.5H13.5V4.5C13.5 3.94772 13.0523 3.5 12.5 3.5H3.5C2.94772 3.5 2.5 3.94772 2.5 4.5Z"
            fill="#91C1EE"
            stroke="#3867A5"
            strokeLinecap="round"
        />
        <path
            d="M10.5 4V3C10.5 2.72386 10.2761 2.5 10 2.5H6C5.72386 2.5 5.5 2.72386 5.5 3V4C5.5 4.27614 5.72386 4.5 6 4.5H10C10.2761 4.5 10.5 4.27614 10.5 4Z"
            fill="#F9EAA9"
            stroke="#BB9631"
            strokeLinecap="round"
        />
        <circle cx="5.5" cy="9.5" fill="#2A4F86" r="1" stroke="#2A4F86" />
        <path d="M4.5 11.5H6.5" stroke="#2A4F86" strokeLinecap="round" />
    </svg>
);

export default Icon;
